
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function ServicesSnapshot() {
  const services = [
    {
      icon: 'ri-fire-line',
      title: 'Fire Extinguishers',
      description: 'Complete range of portable fire extinguishers for all fire classes and applications.',
      image: 'https://readdy.ai/api/search-image?query=professional%20fire%20extinguisher%20collection%20in%20modern%20safety%20equipment%20showroom%2C%20red%20and%20blue%20corporate%20colors%2C%20clean%20industrial%20display%20with%20various%20types%20of%20extinguishers&width=400&height=300&seq=service1&orientation=landscape'
    },
    {
      icon: 'ri-alarm-line',
      title: 'Detection Systems',
      description: 'Advanced smoke, heat, and flame detection systems with smart monitoring capabilities.',
      image: 'https://readdy.ai/api/search-image?query=modern%20fire%20detection%20system%20control%20panel%20with%20sensors%20and%20monitoring%20equipment%2C%20professional%20red%20and%20blue%20lighting%2C%20high-tech%20safety%20control%20room&width=400&height=300&seq=service2&orientation=landscape'
    },
    {
      icon: 'ri-drop-line',
      title: 'Sprinkler Systems',
      description: 'Automatic sprinkler systems designed and installed to protect your valuable assets.',
      image: 'https://readdy.ai/api/search-image?query=professional%20sprinkler%20system%20installation%20in%20modern%20building%20ceiling%2C%20clean%20industrial%20design%20with%20red%20and%20blue%20accent%20lighting%2C%20safety%20equipment%20showcase&width=400&height=300&seq=service3&orientation=landscape'
    },
    {
      icon: 'ri-tools-line',
      title: 'Maintenance Services',
      description: 'Regular inspection, testing, and maintenance to ensure optimal system performance.',
      image: 'https://readdy.ai/api/search-image?query=professional%20technician%20performing%20fire%20safety%20equipment%20maintenance%2C%20modern%20industrial%20setting%20with%20red%20and%20blue%20corporate%20branding%2C%20safety%20service%20professional&width=400&height=300&seq=service4&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-brand-blue mb-6">
            Our Core Services
          </h2>
          <div className="w-24 h-1 bg-brand-red mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive fire safety solutions tailored to protect your business, 
            property, and most importantly, the people who matter to you.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="group card-hover bg-white rounded-xl overflow-hidden"
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-brand-gradient opacity-20 group-hover:opacity-30 transition-opacity duration-300"></div>
                <div className="absolute top-4 left-4 w-12 h-12 bg-white rounded-full flex items-center justify-center">
                  <i className={`${service.icon} text-xl text-brand-red`}></i>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-brand-blue mb-3 group-hover:text-brand-red transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  {service.description}
                </p>
                <Button variant="outline" size="sm" className="w-full">
                  Learn More
                  <i className="ri-arrow-right-line ml-2"></i>
                </Button>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Button size="lg" className="transform hover:scale-105">
            <i className="ri-eye-line mr-2"></i>
            View All Services
          </Button>
        </div>
      </div>
    </section>
  );
}
